import React from 'react';
import { X, Download } from 'lucide-react';

interface Props {
  imageUrl: string;
  careerTitle: string;
  onClose: () => void;
}

export const VisionBoardModal: React.FC<Props> = ({ imageUrl, careerTitle, onClose }) => {
  
  // Detect if it's a URL (Storage) or Base64 (Legacy/Client)
  const isUrl = imageUrl.startsWith('http');
  const isDataUri = imageUrl.startsWith('data:');
  const src = isUrl || isDataUri ? imageUrl : `data:image/png;base64,${imageUrl}`;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-fade-in">
      <div className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden shadow-2xl border border-white/10 flex flex-col items-center">
        
        {/* Header */}
        <div className="absolute top-0 left-0 right-0 p-4 bg-gradient-to-b from-black/80 to-transparent flex justify-between items-start z-10">
            <div>
                <h3 className="text-white font-bold text-lg drop-shadow-md">{careerTitle}</h3>
                <p className="text-white/60 text-xs uppercase tracking-wider">Vision Board</p>
            </div>
            <button onClick={onClose} className="p-2 bg-black/50 hover:bg-white/20 text-white rounded-full backdrop-blur-sm transition-colors">
                <X size={24} />
            </button>
        </div>

        {/* Image */}
        <div className="w-full aspect-video md:aspect-auto md:h-[80vh] flex items-center justify-center bg-zinc-900">
             <img 
                src={src} 
                alt={`Vision board for ${careerTitle}`} 
                className="max-w-full max-h-full object-contain shadow-2xl animate-scale-up"
             />
        </div>

        {/* Footer Actions */}
        <div className="absolute bottom-8 flex gap-4">
             <a 
                href={src} 
                download={`kai-vision-${careerTitle.toLowerCase().replace(/\s+/g, '-')}.png`}
                target={isUrl ? "_blank" : undefined}
                rel={isUrl ? "noopener noreferrer" : undefined}
                className="flex items-center gap-2 px-6 py-3 bg-white text-black rounded-full font-bold hover:bg-gray-200 transition-colors shadow-lg"
             >
                <Download size={18} />
                Save Vision
             </a>
        </div>
      </div>
    </div>
  );
};